<div class="container">
  <div class="row">
    <div class="col-md-12">
      @if (application$ | async; as application) {
      <h1 rtl class="main-heading">{{ application.name }}</h1>
      }
    </div>
  </div>

  <nav mat-tab-nav-bar class="d-none d-sm-flex" animationDuration="2000ms" [tabPanel]="tabPanel">
    @for (e of appTabs(); track e.link) {
    @if (!e.hidden) {
    <a mat-tab-link [routerLink]="e.link" routerLinkActive #rla="routerLinkActive" [active]="rla.isActive"
      [disabled]="e.auth && !(isAuthenticated$ | async)">
      <mat-icon>{{e.icon}}</mat-icon>
      {{e.label | translate}}
    </a>
    }
    }
  </nav>

  <nav class="nav-responsive d-sm-none d-flex justify-content-center">
    <mat-select [value]="activeTab()">
      @for (e of appTabs(); track e.link) {
      @if (!e.hidden) {
      <mat-option routerLinkActive #rla="routerLinkActive" [value]="e" [routerLink]="e.link" [selected]="rla.isActive"
        [disabled]="e.auth && !(isAuthenticated$ | async)">
        {{e.label | translate}}
      </mat-option>
      }
      }
    </mat-select>
  </nav>

  <mat-tab-nav-panel #tabPanel>
    <div [class.animation-ready]="animationReady" [@routeAnimations]="animationReady ? prepareRoute(o) : ''">
      <router-outlet #o="outlet"></router-outlet>
    </div>
  </mat-tab-nav-panel>
</div>